export default __webpack_public_path__ + "static/media/copy_icon_disabled.171fde74.svg";